import { lazy } from 'react';
import * as routePath from '../route-path';
// import { staffRoutes } from './staff-routes';
import { userRoutes } from './user-routes';
import { authRoutes } from './auth-routes';
import { walletRoutes } from './wallet-routes';
import { libraryRoutes } from './library-routes';
import { templateRoutes } from './template-routes';
import { cartRoutes } from './cart-routes';
import { supportRoutes } from './suppport-routes';
import { campaignRoutes } from './campaign-routes';
import { startedRoutes } from './started-routes';
import { audiencesRoutes } from './audiences-routes';
import { creativeRoutes } from './creatives-routes';
import { ownTemplateRoutes } from './own-template-routes';
import { analyticRoutes } from './analytic-routes';
import { advertiserRoutes } from './advertiser-routes';

const ExampleComponentsPage = lazy(() =>
  import('components/Pages/ExampleComponents')
);

const routes = [
  ...startedRoutes,
  ...audiencesRoutes,
  ...userRoutes,
  ...authRoutes,
  ...walletRoutes,
  ...templateRoutes,
  ...cartRoutes,
  ...supportRoutes,
  ...creativeRoutes,
  ...ownTemplateRoutes,
  ...analyticRoutes,
  ...campaignRoutes,
  ...libraryRoutes,
  ...advertiserRoutes,
  {
    path: routePath.COMPONENTS,
    component: ExampleComponentsPage,
    exact: true,
    hide: ['local', 'development'].indexOf(process.env.REACT_APP_NODE_ENV) < 0,
  },
];
export default routes;
